module.exports = __webpack_public_path__ + "img/blocking.e166e12b.svg";